import React from 'react';
import { ctaLink, logoUrl } from '../data/mock';

const Footer = () => {
  const handleCTAClick = () => {
    if (window.fbq) {
      window.fbq('track', 'Subscribe');
    }
  };

  return (
    <footer className="bg-[#191919] py-8 px-[25px] md:px-[75px] lg:px-[100px]">
      <div className="max-w-5xl mx-auto">
        <div className="text-center">
          <p className="text-[#F8F8F8]/50 text-sm">
            © 2025 Fira Indicator. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
